import React from 'react'

import RecommendedPartnerTabLink from '@/pages/professionalNetworkRelationships/components/RecommendedPartnerModal/components/RecommendedPartnerTabLink'
import { useRecommendedPartnerSteps } from '@/pages/professionalNetworkRelationships/hooks/useRecommendedPartnerSteps'

const RecommendedPartnerTabLinks: React.FC = () => {
  const { tabbedStepElements } = useRecommendedPartnerSteps()

  return (
    <section className="flex flex-col md:flex-row md:flex-wrap">
      {tabbedStepElements.map((stepElement, index) => (
        <RecommendedPartnerTabLink
          key={index}
          stepElement={stepElement}
          index={index}
        />
      ))}
    </section>
  )
}

export default RecommendedPartnerTabLinks
